<template>
	<section class='knd-map m-b-md'>

		<div class='knd-map__content'>
			<div class='container-map' ref='chart'>
		</div>

		<div class='knd-top'>
			<div class='knd-top__masked'>
				<ul>
					<li class='knd-top__item' v-for='(item, index) in data' :key="'gemeente' + index">
						<span class='knd-top__number'>{{index + 1}} </span>
						<span>{{item.gemeente}}</span>
						<span> - {{item.waarde}}%</span>
					</li>
				</ul>	
			</div>
		</div>


			<Tooltip :tooltip="tooltip" :showTooltip="showTooltip">
				{{this.tooltip?.info?.GM_NAAM}}
				<div>{{this.tooltip?.info?.woningbezit}}% aandeel tweede woningen</div>
			</Tooltip>
		</div>
		<div class='knd-source knd-text-sm'>
			Bron: Kadaster (juli 2021)
		</div>
	</section>
</template>

<script>
	import gemeenteData from '@/assets/geo/gemeente_2021_v1.json';
	import data from '@/assets/tweede_woning.csv';

	import * as topojson from 'topojson';

	import Tooltip from './tooltip/';
	
	import MapChart from './choropleth';

	import './kaart.scss';

	const vueObject = {
		props: ['data'],
		mounted: function() {
			this.renderChart();
		},
		components: {Tooltip},
		data: function() {
			return {
				highlight: {},
				tooltip: undefined,
				showTooltip: false,
				showReset: false,
				overlayText: '',
				data: data.sort((a, b) => { return a.woningbezit < b.woningbezit })
			}
		},
		methods: {
			combineData(topo, data) {
				topo.features.forEach(d => {
					let naam = d.properties.GM_NAAM;
					const found = data.find(element => element.gemeente === naam);

					if(!found) return;

					d.properties.woningbezit = found.waarde;
				})
			},

			renderChart() {
				this.NLGemeente = topojson.feature(gemeenteData, gemeenteData.objects.gemeente_2021_v1);

				this.combineData(this.NLGemeente, data)

				this.chart = new MapChart()
					.container(this.$refs.chart)
					.data(this.NLGemeente)
					.margin({top: 10, right: 10, bottom: 10, left: 10})
					.height(true)
					.width(true)
					.className(d => { return `knd-path knd-${d.GM_CODE}`})
					.onMouseOver((event, d) => this.onShowTooltip(event, d))
					.onMouseOut(d => this.hideTooltip())
					.render()
					.renderChoropleth({
						value: d => d.properties.woningbezit,
						unknown: '#ececec'
					});

				// this.setZoom();
				// this.setAutocomplete();
			},

			async setZoom() {
				const CustomZoom = await import('./zoom/zoom');

				Object.assign(MapChart.prototype, CustomZoom.default);
				this.chart.setZoom();

				this.chart.onClick((event, d) => {
					this.chart.zoomTo(d);
				});
			},

			async setAutocomplete() {
				const AutoComplete = await import('@/components/autocomplete/autocomplete');

				let el = this.$refs.awesomplete;

				let data = this.NLGemeente.features.map(d => {
					return {label: d.properties.GM_NAAM, value: d.properties.GM_CODE}
				});

				let auto = new AutoComplete.default(el, data, this.onSearch);
			},

			onSearch(value) {
				let selected = this.chart.select(`.knd-${value}`);
				// this.chart.zoomTo(selected.datum());
			},

			onShowTooltip(event, d) {
				this.tooltip = {
					x: event.x,
					y: event.y,
					info: d.properties
				};

				this.showTooltip = true;
			},

			hideTooltip() {
				this.showTooltip = false;
			}
		}
	}

	export default vueObject;

</script>

